import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { refreshConversation, refreshInbox } from '../../lib/queries';
import { checkLiveSession } from '../../lib/session';
import { refreshWork } from '../../lib/workItems';
import { startLive } from '../../lib/socket';

/**
 * Conecta el canal en vivo mientras la bandeja está abierta. Cada aviso solo invalida consultas: los datos
 * llegan por HTTP con los mismos permisos. Al reconectar se refresca todo.
 */
export function LiveBridge() {
  const client = useQueryClient();

  useEffect(() => startLive({
    onChange: (change) => {
      if (change.kind === 'conversation') void refreshConversation(client, change.id);
      else if (change.kind === 'access') void client.invalidateQueries();
      else if (change.kind === 'workItem') void refreshWork(client);
      else void refreshInbox(client);
    },
    onReconnect: () => void client.invalidateQueries(),
    onRejected: (signal) => checkLiveSession(client, signal),
  }), [client]);

  return null;
}
